<template>
  <div class="full_page" v-if="web_account_list.display_data === 1">

    <div v-if="show_dialog === 1">
      <div class="overlay_back"></div>
      <div class="edit_contact_dialog">
        <table class = "table_box bold_font">
          <tbody>
          <tr>
            <td class="table_td">Phone#</td>
            <td class="table_td">
              <input
                  type="text"
                  id="dialog_phone"
                  class=""
                  :value="dialog_phone"
                  @input="dialog_phone = $event.target.value"
              >
            </td>
          </tr>
          <tr>
            <td class="table_td">Contact</td>
            <td class="table_td">
              <input
                  type="text"
                  id="dialog_person"
                  class=""
                  :value="dialog_person"
                  @input="dialog_person = $event.target.value"
              >
            </td>
          </tr>
          <tr class="table_td">
            <td></td>
            <td>
              <button class="shop_save_button" @click="dialog_button_clicked_action()">Save Contact Data</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h1>Weedmap Shops</h1>

    <div class="row">

      <div class="col-3 top_dropdown bold_font">
        Show
        <select class="sorting_display" @change="changeDisplay($event)" v-model="selectedDisplay">
          <option v-for="display in select_display" :value="display.select_display_id" :key="display.select_display_id">{{display.display_name}}</option>
        </select>
      </div>

      <div class="col-2 top_dropdown bold_font">
        Sorting
        <select class="sorting_selection" @change="changeSorting($event)" v-model="selectedSorting" :disabled="web_account_list_loading">
          <option v-for="sorting in sort_options" :value="sorting.sorting_type_id" :key="sorting.sorting_type_id">{{sorting.sorting_name}}</option>
        </select>
      </div>


      <div class="col-5">
      </div>
      <div class="col-2">
        <template v-if="selectedDisplay === 5">
          today={{web_account_list.days.day_0}},
          1d={{web_account_list.days.day_1}},
          2d={{web_account_list.days.day_2}},
          plus={{web_account_list.days.day_plus}}
        </template>
      </div>


    </div>

    <div class="row">
      <div class="col-12">
        <table class="table table-striped table-bordered table-hover table-condensed">
          <thead>
          <tr>
            <th>#</th>
            <th>Scan Time</th>
            <th>Shop Name</th>

            <th v-if="selectedDisplay < 5">Latest Order</th>
            <th v-if="selectedDisplay < 5">Missing Count</th>

            <th v-if="selectedDisplay === 1">Compare Items</th>
            <th v-if="selectedDisplay === 2">Missing Items</th>
            <th v-if="selectedDisplay === 3">Missing Items+</th>
            <th v-if="selectedDisplay === 4 || selectedDisplay === 5">Parsed Items</th>
            <th v-if="selectedDisplay === 5">Not Found Items</th>

          </tr>
          </thead>
          <tbody>


          <tr v-for="(scan,list_index) in web_account_list.list" v-bind:key="scan.id">

            <td class="position_number">{{scan.position}}</td>

            <template v-if="selectedDisplay < 5">
              <td style="white-space:nowrap;">{{scan.scan_time}}
                <template v-if="scan.special_text"><div class="special_text">{{scan.special_text}}</div></template>
              </td>
            </template>
            <template v-else>
              <td>{{scan.scan_time}}
                <template v-if="scan.special_text"><div class="special_text">{{scan.special_text}}</div></template>
              </td>
            </template>

            <td>
              <a v-bind:href=scan.request_url target="_blank">{{scan.shop_name}}</a>
              <div class="customer_id_shop">{{scan.customer_id_shop}}</div>
              <div class="shop_phone_number" v-if="scan.contact_phone">{{scan.contact_phone}}</div>
              <div class="shop_contact_person" v-if="scan.contact_person">{{scan.contact_person}}</div>
              <button class="shop_edit_add_button" @click="edit_phone_contact(scan.customer_id,scan.contact_phone,scan.contact_person,scan.shop_number,list_index)">Contact</button>
            </td>

            <td v-if="selectedDisplay < 5" style="white-space:nowrap;">{{scan.order_created_on_latest}}</td>
            <td v-if="selectedDisplay < 5" >{{scan.missing_count_simple}}</td>

            <template v-if="selectedDisplay === 1">

                <td>
                <table>
                  <thead>
                  <tr>
                    <th>Order Line Item</th>
                    <th>Website</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="result in scan.result_array" v-bind:key="result">
                      <td v-if="result.found === 1" class="found_items" style="text-align: left">{{result.product_name}}</td>
                      <td v-if="result.found === 0" class="missing_red" style="text-align: left">{{result.product_name}}</td>
                      <td style="white-space:nowrap;text-align: left">{{result.matching_string}}</td>
                  </tr>
                  </tbody>
                </table>
              </td>
            </template>

            <td v-if="selectedDisplay === 2">
              <div v-for="missing_item in scan.missing_array" v-bind:key="missing_item" style="white-space:nowrap;text-align: left;">
                  <div v-if="missing_item.type === 1" class="found_items" style="white-space:nowrap;text-align: left">{{missing_item.product_name_simple}}</div>
              </div>
            </td>

            <td v-if="selectedDisplay === 3">
              <div v-for="missing_item in scan.missing_array" v-bind:key="missing_item" style="white-space:nowrap;text-align: left;">
                  <div v-if="missing_item.type === 1" class="found_items" style="white-space:nowrap;text-align: left">{{missing_item.product_name_simple}}</div>
                  <div v-if="missing_item.type === 9" class="never_blue" style="white-space:nowrap;text-align: left">{{missing_item.product_name_simple}}</div>
              </div>
            </td>

            <td v-if="selectedDisplay === 4">
              <div v-for="parsed_item in scan.parsed_array" v-bind:key="parsed_item" style="white-space:nowrap;text-align: left;">
                {{parsed_item}}
              </div>
            </td>

            <template v-if="selectedDisplay === 5">
              <td>
                <table>
                  <thead>
                  <tr>
                    <th>Order Item</th>
                    <th>Website</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="result in scan.result_array" v-bind:key="result">
                    <td v-if="result.found === 1" class="found_items" style="text-align: left">{{result.product_name}}</td>
                    <td v-if="result.found === 0" class="missing_red" style="text-align: left">{{result.product_name}}</td>
                    <td style="text-align: left">{{result.matching_string}}</td>
                  </tr>
                  </tbody>
                </table>
              </td>
              <td>
                <div v-for="parsed_item in scan.web_items_2d_json" v-bind:key="parsed_item" style="text-align: left;">
                  <template v-if="parsed_item.found === 0">
                    {{parsed_item.web_item}}
                  </template>
                </div>
              </td>
            </template>

          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      show_never_ordered: false,
      sort_options: [
        {'sorting_type_id':0, 'sorting_name':'Oldest Order Date'},
        {'sorting_type_id':1, 'sorting_name':'Most missing'},
        {'sorting_type_id':2, 'sorting_name':'Scanned'},
      ],
      selectedSorting: 0,

      select_display: [
        {'select_display_id':1, 'display_name':'Compare Items'},
        {'select_display_id':2, 'display_name':'Missing Items Sales Person'},
        {'select_display_id':3, 'display_name':'Missing Items + Never Ordered'},
        {'select_display_id':4, 'display_name':'Parsed Items'},
        {'select_display_id':5, 'display_name':'Quality Control'},
      ],

      selectedDisplay: 1,

      show_dialog: 0,
      dialog_customer_id: 0,
      shop_number: 0,
      dialog_phone: '',
      dialog_person: '',
      dialog_shop_number: 0,
      dialog_index: 0,
    }
  },
  computed: {
    ...mapGetters({
      web_account_list: 'admin/web_account_list',
      store_web_shop_contact: 'admin/store_web_shop_contact',
      web_account_list_loading: 'admin/web_account_list_loading',
    }),
  },
  watch: {
    // web_account_list: async function () {
    //  if(this.web_account_list.adminid === 38) { // Christian list for debugging
    //    this.select_display = [
    //      {'select_display_id':1, 'display_name':'* Compare Items'},
    //      {'select_display_id':2, 'display_name':'* Missing Items Sales Person'},
    //      {'select_display_id':3, 'display_name':'* Missing Items + Never Ordered'},
    //      {'select_display_id':4, 'display_name':'* Parsed Items'},
    //      {'select_display_id':5, 'display_name':'* Compare + Not Found'},
    //    ];
    //  }
    // },
  },
  created() {
    this.selectedSorting = localStorage.getItem('selected_sorting');
    if(this.selectedSorting === null) {
      this.selectedSorting = 0;
      localStorage.setItem('selected_sorting', this.selectedSorting);
    }
    // this.selectedDisplay = localStorage.getItem('select_display');
    // if(this.selectedDisplay === null) {
    //   this.selectedDisplay = 0;
    //   localStorage.setItem('select_display', this.selectedDisplay);
    // }
  },
  mounted() {
    this.get_web_accounts_list();
    this.selectedDisplay = 1;
  },
  methods: {


    dialog_button_clicked_action: function() {
      // 719885 has test data
      this.web_account_list.list[this.dialog_index].contact_phone  = this.dialog_phone; // Show it temp. on this data array, reload will provide new.
      this.web_account_list.list[this.dialog_index].contact_person = this.dialog_person;
      this.show_dialog = 0;
      this.$store.dispatch('admin/storeWebShopContact', {'customer_id': this.dialog_customer_id, 'shop_number': this.dialog_shop_number, 'contact_phone': this.dialog_phone, 'contact_person': this.dialog_person});
    },
    edit_phone_contact(customer_id,contact_phone,contact_person,shop_number,index) {
      this.dialog_customer_id = customer_id;
      this.dialog_phone = contact_phone;
      this.dialog_person = contact_person;
      this.dialog_shop_number = shop_number;
      this.dialog_index = index;
      this.show_dialog = 1;
    },
    changeSorting (event) {
      this.selectedSorting = Number(event.target.options[event.target.options.selectedIndex].value);
      localStorage.setItem('selected_sorting', this.selectedSorting);
      this.get_web_accounts_list ()
    },
    changeDisplay (event) {
      this.selectedDisplay = Number(event.target.options[event.target.options.selectedIndex].value);
      // localStorage.setItem('select_display', this.selectedDisplay);
    },
    get_web_accounts_list () {
        this.$store.dispatch('admin/getWebAccountsList', {'sort_type':this.selectedSorting});
    },
    set_never_ordered (state_of_never) {
      this.show_never_ordered = state_of_never;
    },
  }
}
</script>

<style scoped>

.full_page {
  margin-left: 20px;
  margin-right: 20px;
}

.never_blue {
  color: blue;
}

.missing_red {
  color: red;
}
.found_items {
  color: black;
}

.position_number {
  font-weight: bolder;
}

.customer_id_shop {
  margin-top: 5px;
  color: black;
}

.shop_phone_number {
  margin-top: 5px;
  color: blue;
}

.shop_contact_person {
  margin-top: 5px;
  color: blue;
}


.special_text {
  margin-top: 5px;
  color: red;
  font-weight: bolder;
}

.top_dropdown {
  margin-bottom: 8px;
}

.shop_edit_add_button {
  color: black;
  background-color: lightskyblue;
  padding: 5px 10px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: bolder;
  margin-top: 5px;
}

.shop_save_button {
  color: black;
  background-color: lightskyblue;
  padding: 5px 10px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 600;
  margin: 7px;
}

.bold_font {
  font-weight: bolder;
}

.table_box {
//border: 1px solid red;
  border-radius: 7px;
  width: 100%;
  background: #FFF;
}

.table_td {
  text-align: left;
  white-space:nowrap;
  //font-size: larger;
  padding: 7px;
}

.overlay_back {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  background-color: rgba(8, 8, 8, 0.30);
  height: 100vh;
}

.edit_contact_dialog{
  position: fixed;
  z-index: 1000;
  top: calc(50% - 150px);
  left: 38%;
  background-color: white;
  border-radius: 8px;
  padding: 13px;
}





</style>
